import { render } from "./QuestionComponent.vue?vue&type=template&id=1b6521dd&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"

import "./QuestionComponent.vue?vue&type=style&index=0&id=1b6521dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6521dd"]])

export default __exports__